module.exports = __webpack_public_path__ + "img/vue3-web3-5.53a19aa0.jpg";